import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import OnepostComposer from '../../../bundles/OnepostComposer/components/OnepostComposer';
import SocialPostsList from './SocialPostsList';
import Popup from "reactjs-popup";
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';

const composePostModalContentStyle = {
  "background": "var(--od-surface, #fff)",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "880px",
  "padding": "0px",
  "overflow": "hidden"
}

const ScheduledPosts = ({
  csrfToken,
  team,
  currentUser,
  dataTableDataSource,
  reloadKey,
  deletePost,
  postToEdit,
  onepostPublicKey,
  authorizedPages,
  postToEditChanged,
  updatePost,
  newPost,
  newPostChanged,
  createPost,
  hasPosts,
  hasPostsChanged,
  openNewPost
}) => {
  useEffect(() => {
    if(openNewPost && authorizedPages.length > 0 && currentUser.can_manage_posts) {
      newPostChanged({ open: true });
    }
  }, []);

  return (
    <div>
      <ToastContainer icon={false} />
      <SocialPostsList
        view="scheduled"
        dataSource={dataTableDataSource}
        team={team}
        currentUser={currentUser}
        authorizedPages={authorizedPages}
        hasPosts={hasPosts}
        reloadKey={reloadKey}
        onNewPost={() => newPostChanged({ open: true })}
        onEditPost={(post) => postToEditChanged(post)}
        onRemovePost={(post) => deletePost(csrfToken, team, post)}
      />
      <Popup
        open={Object.keys(newPost).length > 0}
        contentStyle={composePostModalContentStyle}
        closeOnDocumentClick={false}
        onClose={() => newPostChanged({})}
        >
        <div className="row">
          <div className="col-12">
            <div className="col-xs-auto position-absolute"
                 style={{
                   "right": "37px",
                   "top": "26px"
                 }}>
              <a href="#"
                 style={{"fontSize": "24px"}}
                 className="text-dark"
                 onClick={(e) => {
                   e.preventDefault();
                   newPostChanged({});
                 }} >
                <i className="fal fa-times"></i>
              </a>
            </div>
            <OnepostComposer publicKey={onepostPublicKey}
                             onSuccess={
                               (data) => {
                                  hasPostsChanged(true);
                                  createPost(csrfToken, team, data.token, newPost);
                               }
                             }
                             onFailure={
                               (error) => {
                                 var messages = Object.keys(error).map((attribute) => (
                                   error[attribute].map((message) => (
                                     (attribute + " " + message)
                                   ))
                                 )).flat().join(", ");

                                 toast.error("An error occurred while processing your request (" + messages + ")", {
                                   position: toast.POSITION.TOP_CENTER,
                                   draggable: false,
                                   closeOnClick: false,
                                   autoClose: 5000,
                                   hideProgressBar: true
                                 });
                               }
                             }
                             authorizedPageIds={authorizedPages.map((ap) => ap.onepost_id)} />
          </div>
        </div>
      </Popup>
      <Popup
       open={Object.keys(postToEdit).length > 0}
       contentStyle={composePostModalContentStyle}
       closeOnDocumentClick={false}
       onClose={() => postToEditChanged({})}
      >
       <div className="row">
         <div className="col-12">
           <div className="col-xs-auto position-absolute"
                style={{
                  "right": "37px",
                  "top": "26px"
                }}>
             <a href="#"
                style={{"fontSize": "24px"}}
                className="text-dark"
                onClick={(e) => {
                  e.preventDefault();
                  postToEditChanged({});
                }} >
               <i className="fal fa-times"></i>
             </a>
           </div>
           <OnepostComposer publicKey={onepostPublicKey}
                            onSuccess={
                              (data) => {
                                updatePost(csrfToken, team, postToEdit, data.token);
                              }
                            }
                            onFailure={
                              (error) => {
                                toast.error("An error occurred while processing your request", {
                                  position: toast.POSITION.TOP_CENTER,
                                  draggable: false,
                                  closeOnClick: false,
                                  autoClose: 5000,
                                  hideProgressBar: true
                                });
                              }
                            }
                            token={postToEdit.onepost_token}
                            imageIds={(postToEdit.calendar_event_attachments || []).map((cea) => cea.onepost_id)}
                            authorizedPageIds={authorizedPages.map((ap) => ap.onepost_id)} />
         </div>
       </div>
      </Popup>
    </div>
  )
};

ScheduledPosts.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  dataTableDataSource: PropTypes.string.isRequired,
  reloadKey: PropTypes.number,
  deletePost: PropTypes.func.isRequired,
  postToEdit: PropTypes.object,
  onepostPublicKey: PropTypes.string.isRequired,
  authorizedPages: PropTypes.array,
  postToEditChanged: PropTypes.func.isRequired,
  updatePost: PropTypes.func.isRequired,
  newPost: PropTypes.object,
  newPostChanged: PropTypes.func.isRequired,
  createPost: PropTypes.func.isRequired,
  hasPosts: PropTypes.bool,
  hasPostsChanged: PropTypes.func.isRequired,
  openNewPost: PropTypes.bool
};

export default ScheduledPosts;
